<template>
  <faq-main />
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class FaqPage extends Vue {}

export default toNative(FaqPage)
</script>
